import React from 'react';
import { Info } from 'lucide-react';

/**
 * Persistent banner shown on every Optimar demo page so users never
 * forget the data is Optimar-inspired demo data, not real Optimar data.
 */
const DemoBanner = () => (
  <div
    data-testid="optimar-demo-banner"
    className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-amber-900"
  >
    <Info className="mt-0.5 h-5 w-5 flex-shrink-0" />
    <div className="text-sm leading-relaxed">
      <strong className="font-semibold">Optimar-inspired demo data.</strong>{' '}
      This view does not represent real Optimar customer, plant, SCADA, or
      production data. It illustrates how a seafood-processing line could map
      to PureSustain.
    </div>
  </div>
);

export default DemoBanner;
